import { useEffect } from 'react';
import { useToast } from '@/stores/toast';

const COLORS = {
  success: 'bg-emerald-600',
  error: 'bg-red-500',
  info: 'bg-slate-700',
} as const;

const ICONS = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
} as const;

export function ToastHost(): JSX.Element {
  const toasts = useToast((s) => s.toasts);
  const remove = useToast((s) => s.remove);

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => (
        <ToastItem key={t.id} {...t} onDone={() => remove(t.id)} />
      ))}
    </div>
  );
}

function ToastItem({
  id,
  message,
  variant,
  onDone,
}: {
  id: number;
  message: string;
  variant: 'success' | 'error' | 'info';
  onDone: () => void;
}): JSX.Element {
  useEffect(() => {
    const t = setTimeout(onDone, 2500);
    return () => clearTimeout(t);
  }, [id, onDone]);
  return (
    <div
      className={`${COLORS[variant]} text-white px-5 py-3 rounded-xl shadow-lg text-sm font-medium animate-fade-in pointer-events-auto`}
    >
      {ICONS[variant]} {message}
    </div>
  );
}
